{
  "title": "Vortex Warp",
  "source": "Strixhaven: A Curriculum of Chaos",
  "levelAndSchool": "2nd-level Conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You magically twist space around another creature you can see within range. The target must succeed on a Constitution saving throw (the target can choose to fail), or the target is teleported to an unoccupied space of your choice that you can see within range. The chosen space must be on a surface or in a liquid that can support the target without the target having to squeeze.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the range of the spell increases by 30 feet for each slot level above 2nd."
  ],
  "spellLists": ["artificer", "sorcerer", "wizard"]
}
